import { render, staticRenderFns } from "./TheDimensionsVariables.vue?vue&type=template&id=173ea710&"
import script from "./TheDimensionsVariables.vue?vue&type=script&lang=js&"
export * from "./TheDimensionsVariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheDimensionsVariables.vue"
export default component.exports